import { InputTextAccordionProps } from "./types"
import React from "react"
import { StyleSheet, Platform } from "~/ui/primitives"
import styled from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"
import { ButtonSolid } from "~components/button"
import Icon from "~widgets/icon"

const ButtonWrapper = styled.View`
  flex: 1;
  flex-direction: row;
`
const Wrap = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
  margin: 0 15px;
  border-bottom-color: #ccc;
  border-bottom-width: ${StyleSheet.hairlineWidth}px;
  background-color: #fff;
`
const InputWrap = styled.View`
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const Input = styled.TextInput`
  flex: 1;
  height: 50px;
  padding: 15px;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.text};
  text-align: right;
`
const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.text};
`
const IText = styled(TextCore)`
  margin: 0 5px;
`
const SingleTextFieldRow: React.FC<InputTextAccordionProps> = ({
  accordionProps,
  inputTextProps,
  buttonTextProps,
  buttonCoreProps,
  FunctionButton,
  onClear,
}) => {
  return (
    <Wrap {...accordionProps}>
      <Text>{accordionProps?.label}</Text>
      {buttonTextProps != null ? (
        <ButtonWrapper>
          <Input
            {...inputTextProps}
            style={{ flex: 1 }}
            editable={inputTextProps?.editable}
            placeholder={inputTextProps?.placeholder}
            placeholderTextColor="#AAAAAA"
            underlineColorAndroid="transparent"
            clearButtonMode="while-editing"
          ></Input>
          <ButtonSolid
            {...buttonCoreProps}
            text={buttonTextProps.text}
            // loading={loading}
            // disabled={formErr || !isAgreePrivacy}
            // onClick={onLogin}
          />
        </ButtonWrapper>
      ) : (
        <InputWrap>
          <Input
            {...inputTextProps}
            placeholderTextColor="#AAAAAA"
            underlineColorAndroid="transparent"
            clearButtonMode="while-editing"
          ></Input>
          {Platform.OS === "android" && inputTextProps.value ? (
            <IText onClick={onClear}>
              <Icon name={"qingchu"} color={"#e2e2e2"} size={14} />
            </IText>
          ) : null}
          {FunctionButton && <FunctionButton />}
        </InputWrap>
      )}
    </Wrap>
  )
}
export default SingleTextFieldRow
